import { useEffect } from 'react'
import { useFeature } from '../hooks'
import { getReplay } from '@sentry/react'

export const ReplayProvider = () => {
  const shouldRecordSession = useFeature('should-record-session')

  const replay = getReplay()

  useEffect(() => {
    if (shouldRecordSession && replay) {
      try {
        replay.start()
      } catch (err) {
        // let's not block the app if replay fails
      }

      const flush = async () => await replay?.flush()

      window.addEventListener('beforeunload', flush)
      const interval = setInterval(flush, 15 * 1000)
      return () => {
        window.removeEventListener('beforeunload', flush)
        clearInterval(interval)
      }
    }
  }, [shouldRecordSession, replay])

  return null
}
